import type { RepairPartsFilterConfig } from '../types';

export const buildODataFilter = (config: RepairPartsFilterConfig): string => {
  const filters: string[] = [];

  if (config.companyName) {
    filters.push(`companyName eq '${escapeODataString(config.companyName)}'`);
  }

  if (config.partNumber) {
    filters.push(`partNumber eq '${escapeODataString(config.partNumber)}'`);
  }

  if (config.partCategory) {
    filters.push(`partCategory eq '${escapeODataString(config.partCategory)}'`);
  }

  if (config.manufacturer) {
    filters.push(`manufacturer eq '${escapeODataString(config.manufacturer)}'`);
  }

  if (config.hasQuantityAvailable) {
    filters.push('quantityAvailable gt 0');
  }

  if (config.minCost !== undefined) {
    filters.push(`cost ge ${config.minCost}`);
  }

  if (config.maxCost !== undefined) {
    filters.push(`cost le ${config.maxCost}`);
  }

  if (config.location) {
    filters.push(`location eq '${escapeODataString(config.location)}'`);
  }

  return filters.join(' and ');
};

export const escapeODataString = (value: string): string => {
  return value.replace(/'/g, "''");
};

export const buildODataContainsFilter = (
  field: string,
  value: string
): string => {
  return `contains(${field}, '${escapeODataString(value)}')`;
};

export const buildODataStartsWithFilter = (
  field: string,
  value: string
): string => {
  return `startswith(${field}, '${escapeODataString(value)}')`;
};

export const buildODataInFilter = (field: string, values: string[]): string => {
  const conditions = values.map(v => `${field} eq '${escapeODataString(v)}'`);
  return `(${conditions.join(' or ')})`;
};

export const combineFilters = (...filters: (string | undefined)[]): string => {
  const validFilters = filters.filter(f => f && f.trim() !== '');
  return validFilters.join(' and ');
};

export const filterByCompany = (companyName: string): string => {
  return buildODataFilter({ companyName });
};

export const filterByAvailability = (): string => {
  return buildODataFilter({ hasQuantityAvailable: true });
};

export const filterByCostRange = (minCost: number, maxCost: number): string => {
  return buildODataFilter({ minCost, maxCost });
};

export const searchPartNumber = (searchTerm: string): string => {
  return buildODataContainsFilter('partNumber', searchTerm);
};

export const searchDescription = (searchTerm: string): string => {
  return buildODataContainsFilter('description', searchTerm);
};

export const searchByKeyword = (searchTerm: string): string => {
  return `(${buildODataContainsFilter('partNumber', searchTerm)} or ${buildODataContainsFilter('description', searchTerm)} or ${buildODataContainsFilter('companyName', searchTerm)})`;
};
